export const initialPagination = {
  limit: 9,
  offset: 0
}
